<template>
  <div class="app" v-title data-title="预订服务-广富林文化遗址公园">
    <component :is="headerComponent" :activeIndex="4" />
    <div class="yj-banner rel">
      <img src="@/assets/images/yd-banner.png" class="db wp100" alt="banner">
      <div class="crumbs-nav df align_center justify_end fa_wh box-border">
        <router-link to="/" class="f16 fw">首页</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/yinxiang/index" class="f16 fw">预订服务</router-link>
      </div>
      <div class="yj-banner-tit df align_center flex_column justify_center ts fw">
        <div class="f50 ls1 b">预订服务</div>
        <div class="f17 ls3">Reservation Services</div>
      </div>
    </div>
    <div class="spot-cont mt-40 pb100">
      <div class="spot-tit df align_center justify_center">
        <h2 class="f32 foo pb15">精品酒店</h2>
      </div>
      <div class="tc mt5" v-if="jsData && jsData.Items && jsData.Items.length > 0">
        {{ jsData.Items[0].Remark }}
      </div>
      
      <div class="w1200 auto pt50 pb100" v-if="data && data.length > 0">
        <el-carousel :interval="5000" height="600px">
            <el-carousel-item v-for="item in data" :key="item.Id">
              <div class="rel hotel-box">
                <img v-if="item.Photo" :src="item.Photo + '!/both/2400x1200'" class="db wp100" alt="" />
                <div class="hotel-text abs">
                  <div class="hotel-name f24 ts b fw" v-if="item.Name">{{ item.Name }}</div>
                  <div class="tj cell_bk fw f16 lh18 mt10" v-if="item.Intro">
                    {{ item.Intro | clearHtml(200) }}
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
      </div>
    </div>
    <component :is="bottomComponent" />
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import Bottom from '../../components/bottom.vue'
import promotionService from '@/services/client/cont/promotion'
import hotelService from '@/services/client/cont/hotel'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',
      code: 'app-ydfw-kfzs-js',
      data: null,
      filter: {
        Page: 1,
        PageSize: 20,
      },
      jsData: null,
    }
  },
  components: { Header, Bottom,},
  mounted() {
    this.loadJsData();
    this.loadData();
  },
  methods:{
    loadData() {
      this.data = null;
      hotelService.list(this.filter).then(res => {
        if(res.Code == 200 && res.Data && res.Data.List) {
          this.data = res.Data.List;
        }
      })
    },
    loadJsData() {
      promotionService.detail(this.code).then(res => {
        if(res.Code == 200) {
          let data = res.Data;
          this.jsData = data;
        }
      })
    },
  },

}
</script>

<style>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>



// WEBPACK FOOTER //
// src/views/yuding/hotel.vue